import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-packaging',
  templateUrl: './packaging.component.html',
  styleUrls: ['./packaging.component.scss'],
})
export class PackagingComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
